var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZone3Path(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3840 2329",
    style: {
      enableBackground: "new 0 0 3840 2329"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "z3_path"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E961B1",
      strokeWidth: 49.9449,
      strokeMiterlimit: 10
    },
    d: "M724.261,1064.223 c-2.507-6.774-5.485-13.793-8.975-21.063c0,0-52.747-72.901-84.873-112.941c-32.126-40.04-169.258-254.912-25.538-493.984 c0,0,75.134-13.967,167.289,42.411s227.388,154.811,546.849,109.585c0,0,149.209-50.134,274.24,37.451 s276.442,128.395,404.252,21.529S2133.91,501.766,2375.694,474.5c0,0,114.764-29.952,183.594,36.569 c0,0,20.919,38.92,193.853,27.448c129.7-8.604,214.307,17.591,262.606,85.692"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZone3Path);
export default __webpack_public_path__ + "static/media/zone3-path.128cd7ea.svg";
export { ForwardRef as ReactComponent };